<template>
  <div class="position-modal-wrapper">
    <div class="position-modal">
      <form>
        <!-- NAME -->
        <label for="positionModalName" class="input-label">Име на длъжност</label>
        <div class="input-wrapper" :class="{ 'invalid': !isNameValid }">
          <span class="mck2">s</span>
          <input
            id="positionModalName"
            type="text"
            placeholder="Име на длъжност"
            v-model="position.name"
            @keyup="isNameValid = true"
            @keydown.enter.prevent
          />
        </div>
        <!-- RATE -->
        <label for="positionModalRate" class="input-label">Ставка (€/час)</label>
        <div class="input-wrapper" :class="{ 'invalid': !isRateValid }">
          <span class="mck2">t</span>
          <input
            id="positionModalRate"
            type="number"
            placeholder="Ставка"
            v-model="position.rate"
            @keyup="isRateValid = true"
            @keydown.enter.prevent
          />
        </div>
        <template v-if="users.length">
          <label for="groupModalUsers" class="input-label">Работници, назначени на длъжността:</label>
          <div class="users-list">
            <span class="mck2">s</span>
            <p v-for="u in users" :key="u._id">{{ u.name }}</p>
          </div>
        </template>
        <div class="position-modal-actions">
          <div class="switch-container">
            <label class="switch">
              <input type="checkbox" v-model="position.isActive" />
              <span class="slider"></span>
            </label>
            <label v-if="position.isActive">Активен</label>
            <label v-else>Неактивен</label>
          </div>
          <div class="btns">
            <button class="btn btn-close" @click.prevent="closeModal(false)">
              <span class="mck">F</span>
              Отказ
            </button>
            <button
              v-if="!id"
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="create"
            >
              <span class="mck">B</span>
              Създай
            </button>
            <button v-else class="btn btn-new" type="submit" value="Submit" @click.prevent="edit">
              <span class="mck">B</span>
              Редактирай
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import log from '../mixins/log.js';
export default {
  mixins: [log],
  props: ['id'],
  data() {
    return {
      isNameValid: true,
      isRateValid: true,
      position: {
        name: '',
        rate: null,
        isActive: true
      },
      users: []
    };
  },
  methods: {
    getGroup(id) {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/position/${id}`)
        .then(response => {
          this.position = response.data;
          this.getUsers();
        });
    },
    getUsers() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/position/users/${this.id}`)
        .then(response => {
          this.users = response.data;
        });
    },
    checkForm() {
      if (!this.position.name) {
        this.isNameValid = false;
      }
      if (!this.position.rate) {
        this.isRateValid = false;
      }

      if (this.isNameValid && this.isRateValid) {
        return true;
      }
      return false;
    },
    create() {
      if (this.checkForm()) {
        this.$http
          .post(`${process.env.VUE_APP_BASE_URI}/position`, this.position)
          .then(() => {
            this.$snotify.success('Успешно създадена длъжност. Може да я добавите в профилите на работниците.');
            // this.newLog('newUser', this.user.username);
            this.closeModal(true);
          })
          .catch(error => {
            console.log(error.response);
            this.$snotify.error('Нещо се обърка! Моля опитайте отново.');
          })
          .then(() => {});
      } else {
        // TODO: Do something
      }
    },
    edit() {
      if (this.checkForm()) {
        this.$http
          .put(`${process.env.VUE_APP_BASE_URI}/position`, this.position)
          .then(() => {
            this.$snotify.success('Промените са записани успешно!');

            // this.newLog('editUser', this.user.username);
            this.closeModal(true);
          })
          .catch(error => {
            console.log(error.response);
            this.$snotify.error('Нещо се обърка! Моля опитайте отново.');
          })
          .then(() => {});
      } else {
        // TODO: Do something
      }
    },
    closeModal(update) {
      this.$emit('close', update);
    },
    handleEvents(e) {
      if (e.code === 'Enter') {
        if (this.id) {
          this.edit();
        } else {
          this.create();
        }
      } else if (e.code === 'Escape') {
        this.closeModal(false);
      }
    }
  },
  mounted() {
    if (this.id) {
      this.getGroup(this.id);
    }

    window.addEventListener('keydown', this.handleEvents);
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleEvents);
  }
};
</script>

<style scoped>
.position-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;
}
.position-modal {
  background-color: #fff;
  border-radius: 4px;
  /* border-top: 10px solid #6d2600; */
  display: flex;
  flex-direction: column;
  /* height: 60vh; */
  overflow: auto;
  padding: 10px 20px 0;
  width: 800px;
  -webkit-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  -moz-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
}
.position-modal-permissions {
  background-color: #f4f4f4;
  border-radius: 4px;
  display: flex;
  justify-content: center;
}
.position-modal-actions {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
}
.invalid .mck {
  color: #d91313;
}
.invalid input {
  background-color: #f8dcdc;
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}

/* Responsive */
@media screen and (max-width: 900px) {
  .position-modal {
    width: 90%;
  }
}
@media screen and (max-width: 500px) {
  .position-modal-actions {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .switch-container {
    display: flex;
    justify-content: center;
    margin-bottom: 1em;
  }
  .btns {
    justify-content: center;
  }
  .position-modal-permissions {
    flex-direction: column;
  }
}
@media screen and (max-height: 550px) {
  .position-modal {
    height: 100%;
  }
}
</style>
